import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { ScrollDispatcher } from '@angular/cdk/overlay';

@Directive({
  standalone: true,
  selector: '[disableScrollContainer]'
})
export class DisableScrollContainerDirective {
  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private scrollDispatcher: ScrollDispatcher
  ) {}

  @HostListener('attach')
  disableScroll() {
    const scrollables = this.scrollDispatcher.getAncestorScrollContainers(this.elementRef);
    if (!scrollables.length) return;
    const scrollContainer = scrollables[0].getElementRef().nativeElement;
    this.renderer.addClass(scrollContainer, 'overflow-hidden');
  }

  @HostListener('detach')
  restoreScroll() {
    const scrollables = this.scrollDispatcher.getAncestorScrollContainers(this.elementRef);
    if (!scrollables.length) return;
    const scrollContainer = scrollables[0].getElementRef().nativeElement;
    this.renderer.removeClass(scrollContainer, 'overflow-hidden');
  }
}
